module.exports = __webpack_public_path__ + "static/yoda.a89ea479.png";


//////////////////
// WEBPACK FOOTER
// ./public/static/yoda.png
// module id = 453
// module chunks = 168707334958949